<app-loader [isLoading]="isLoading"></app-loader>
<div class="header">
    <div class="top">
        <a [routerLink]="returnPath">
            <h3>Comedor /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> {{isEditMode ? 'Editar reserva' : 'Añadir reserva'}}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <form [formGroup]="reservationForm" (ngSubmit)="onSubmit()">
        @if(isEditMode){
        Reserva a nombre de {{currentEmployee?.name}}
        }
        <h4>Nombre del trabajador: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <input type="text" matInput placeholder="Buscar trabajador" formControlName="employeeName"
                [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                (optionSelected)="onEmployeeSelected($event)">
                @for (employee of filteredEmployees | async; track employee.personnelnumber) {
                <mat-option [value]="employee">{{employee.name}}</mat-option>
                }
            </mat-autocomplete>
            @if (reservationForm.get('employeeName')?.invalid && reservationForm.get('employeeName')?.touched) {
            <mat-error>
                El nombre del trabajador es requerido
            </mat-error>
            }
        </mat-form-field>

        @if(!isEditMode && !isCookScreenMode) {
        <br><br>
        <h4>Seleccione un día: </h4>
        <mat-form-field appearance="outline" style="width: 500px; margin-bottom: 10px;">
            <mat-label>Seleccionar fecha</mat-label>
            <input matInput [matDatepicker]="picker" [matDatepickerFilter]="dateFilter" formControlName="selectedDate"
                placeholder="Haga clic para seleccionar una fecha" readonly>
            <mat-hint>Solo días laborables disponibles</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (reservationForm.get('selectedDate')?.invalid && reservationForm.get('selectedDate')?.touched) {
            <mat-error>
                @if (reservationForm.get('selectedDate')?.errors?.['required']) {
                La fecha es requerida
                } @else if (reservationForm.get('selectedDate')?.errors?.['pastDate']) {
                No se pueden hacer reservas para fechas pasadas
                } @else if (reservationForm.get('selectedDate')?.errors?.['weekend']) {
                No se pueden hacer reservas los fines de semana
                } @else if (reservationForm.get('selectedDate')?.errors?.['blockedDate']) {
                No se pueden hacer reservas en días festivos
                } @else if (reservationForm.get('selectedDate')?.errors?.['cutoffPassed']) {
                El tiempo límite para reservar esta fecha ha pasado (antes de las 15:00 del día laboral anterior)
                } @else {
                La fecha seleccionada no es válida
                }
            </mat-error>
            }
        </mat-form-field>
        }
        <br>
        <h4>Menú celíaco: </h4>
        <mat-slide-toggle formControlName="isCeliac"></mat-slide-toggle>
        @if (reservationForm.get('isCeliac')?.value) {
        <div class="celiac" style="margin-bottom: -50px;">
            <div class="guest-observations" style="margin-top: 10px;">
                <quill-editor formControlName="celiacObservation" [modules]="modules"
                    [styles]="{height: '120px', marginBottom: '20px'}"></quill-editor>
            </div>
            <mat-error>
                @if (reservationForm.get('celiacObservation')?.invalid &&
                reservationForm.get('celiacObservation')?.touched) {
                Hay que especificar los platos celíacos
                }
            </mat-error>
        </div>
        }
        <!-- @else if (!isEditMode && isCookScreenMode) {
        <br><br>
        <div class="cook-screen-date-info">
            <h4>Fecha de la reserva: </h4>
            <p style="font-size: 16px; color: #333; margin: 10px 0;">
                <strong>Hoy - {{ formatDateForDisplay(getTodaysDate()) }}</strong>
            </p>
        </div>
        } -->

        <br><br>
        <h4>Número de invitados: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <input type="number" matInput placeholder="Número de invitados (0-10)" formControlName="guestCount" min="0"
                max="10">
            @if (reservationForm.get('guestCount')?.invalid && reservationForm.get('guestCount')?.touched) {
            <mat-error>
                El número de invitados es requerido y debe estar entre 0 y 10
            </mat-error>
            }
        </mat-form-field>
        <div class="guest-count-info">
            @if (reservationForm.get('guestCount')?.value > 10) {
            <div class="warning-message">
                El número máximo de invitados permitido es 10. Se ha ajustado el valor
            </div>
            }
        </div>

        <br>
        <!-- General Guest Observations -->
        <h4>Observaciones de los invitados: </h4>
        <div class="guest-observations">
            <quill-editor formControlName="guestsObservation" [modules]="modules"
                [styles]="{height: '120px', marginBottom: '20px'}"></quill-editor>
        </div>

        <!-- Guest Celiac Information Section -->
        @if (guests.length > 0) {
        <div class="guests-section">
            <h4>Información para cada invitado:</h4>
            <div class="guests-container" formArrayName="guests">
                @for (guestControl of guests.controls; track $index) {
                <div class="guest-card" [formGroupName]="$index">
                    <div class="guest-header">
                        <span class="guest-number">Invitado {{$index + 1}}</span>
                        <mat-checkbox formControlName="isCeliac">Celíaco</mat-checkbox>
                    </div>

                    @if (guestControl.get('isCeliac')?.value) {
                    <div class="guest-comments">
                        <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Comentarios para celíaco"
                                formControlName="celiacComments"></textarea>
                            @if (guestControl.get('celiacComments')?.invalid &&
                            guestControl.get('celiacComments')?.touched) {
                            <mat-error>
                                Los comentarios para celíaco son requeridos.
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
        }

        <br><br>
        <div class="buttons">
            <button mat-flat-button id="action" type="submit">
                {{isEditMode ? 'Actualizar reserva' : 'Añadir reserva'}}
            </button>
            <button mat-flat-button id="cancel" type="button" [routerLink]="returnPath">Cancelar</button>
        </div>
    </form>
</div>